export var FakeParticipant;
(function (FakeParticipant) {
    FakeParticipant["LocalScreenShare"] = "LocalScreenShare";
    FakeParticipant["RemoteScreenShare"] = "RemoteScreenShare";
    FakeParticipant["SharedVideo"] = "SharedVideo";
    FakeParticipant["Whiteboard"] = "Whiteboard";
    FakeParticipant["LoadTest"] = "LoadTest";
    FakeParticipant["SharedBrowser"] = "SharedBrowser";
    FakeParticipant["SharedPdf"] = "SharedPdf";
})(FakeParticipant || (FakeParticipant = {}));
